/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Image_Inspector_Snippet_NameInputs */

const en_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} snippet`)
};

const ar_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مقتطف ${i?.label}`)
};

const bn_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} স্নিপেট`)
};

const de_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}-Snippet`)
};

const es_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fragmento de ${i?.label}`)
};

const fr_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`extrait ${i?.label}`)
};

const pt_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`trecho de ${i?.label}`)
};

const zh_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} 片段`)
};

const tr_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} parçacığı`)
};

const ru_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`фрагмент ${i?.label}`)
};

const pl_image_inspector_snippet_name = /** @type {(inputs: Image_Inspector_Snippet_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`fragment ${i?.label}`)
};

/**
* | output |
* | --- |
* | "{label} snippet" |
*
* @param {Image_Inspector_Snippet_NameInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_snippet_name = /** @type {((inputs: Image_Inspector_Snippet_NameInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Snippet_NameInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_snippet_name(inputs)
	if (locale === "bn") return bn_image_inspector_snippet_name(inputs)
	if (locale === "de") return de_image_inspector_snippet_name(inputs)
	if (locale === "es") return es_image_inspector_snippet_name(inputs)
	if (locale === "fr") return fr_image_inspector_snippet_name(inputs)
	if (locale === "pt") return pt_image_inspector_snippet_name(inputs)
	if (locale === "zh") return zh_image_inspector_snippet_name(inputs)
	if (locale === "tr") return tr_image_inspector_snippet_name(inputs)
	if (locale === "ru") return ru_image_inspector_snippet_name(inputs)
	if (locale === "pl") return pl_image_inspector_snippet_name(inputs)
	return en_image_inspector_snippet_name(inputs)
});